import { MessageService } from 'primeng/api';
import { Observer } from 'rxjs';

/** Shown for a 409 when the server's body has no message. */
const DEACTIVATED_MESSAGE = 'This user is deactivated. Reactivate them before sending a password link.';

/**
 * Toasts for UsersApiService.sendPasswordLink, shared by every screen that offers it (spec 004, FR-012). 403s get
 * the global "Permission denied" message from the forbidden interceptor, so they're not toasted again here. A 409
 * means the user is deactivated; the server's message ({ message } from ApiException) says so.
 */
export function passwordLinkObserver(messages: MessageService): Partial<Observer<unknown>> {
  return {
    next: () => messages.add({ severity: 'success', summary: 'Success', detail: 'The email was successfully sent' }),
    error: (err) => {
      if (err?.status === 403) {
        return;
      }
      const detail = err?.status === 409
        ? err.error?.message || DEACTIVATED_MESSAGE
        : 'It was not possible to send the email.';
      messages.add({ severity: 'error', summary: 'Error', detail, life: 5000 });
    }
  };
}
